export default {
    path: 'ws_tool',
    component: () => import(/* webpackChunkName: "login" */ '@/pages/ws/Index'),
    meta: {title: '即时通讯'}
}